import { createSlice } from "@reduxjs/toolkit";

const updateReportSlice = createSlice({
    name: "updateReport",
    initialState: {
        editUploadedFiles: null, // [[{file1}], [{file2}], [{file3}], ...]
        uploadedAccountDetails: null
    },
    reducers: {

        setEditUploadedFiles: (state, { payload }) => {
            state.editUploadedFiles = payload;
        },
        setUploadedAccountDetails: (state, { payload }) => {
            state.uploadedAccountDetails = payload;
        }
    }
});

export const { setEditUploadedFiles, setUploadedAccountDetails} = updateReportSlice.actions;

export default updateReportSlice.reducer;